import React, { Component } from 'react';

class MainAnalytics extends Component {
    render() {
        return (
            <div className="MainAnalytics">

            </div>
        );
    }
};

export default MainAnalytics;



// WEBPACK FOOTER //
// ./src/components/App/components/Main/components/Analytics/MainAnalytics/MainAnalytics.js